<template>
  <b-row>
    <b-col lg="3" md="6" v-if="checkResponsive(SESSION_METRICS.TIME_ABOVE_80_PERCENT_HR)">
      <chart-tab
        v-if="dashboardOnScreen.timeAbove80PercentHrSeconds !== undefined"
        :chart-colors="['#E17070', '#D04A4A', '#CA3131', '#1A1A1D']"
        :chart-value="dashboardOnScreen.timeAbove80PercentHrSeconds"
        :max-value="45"
        label="TIME > 80%"
        :current-metric="currentMetric"
        :metric="SESSION_METRICS.TIME_ABOVE_80_PERCENT_HR"
        :change-selected-metric="changeSelectedMetricAction"
      />
    </b-col>
    <b-col lg="3" md="6" v-if="checkResponsive(SESSION_METRICS.AP)">
      <chart-tab 
        v-if="dashboardOnScreen.ap !== undefined"
        :chart-colors="['#CAAD6B', '#BA9647', '#B08625', '#1A1A1D']"
        :chart-value="dashboardOnScreen.ap"
        :max-value="60"
        label="AP %"
        :current-metric="currentMetric"
        :metric="SESSION_METRICS.AP"
        :change-selected-metric="changeSelectedMetricAction"
      />
    </b-col>
    <b-col lg="3" md="6" v-if="checkResponsive(SESSION_METRICS.WORKLOAD)">
      <chart-tab 
        v-if="dashboardOnScreen.workload !== undefined"
        :chart-colors="['#AB64EF','#8D1DEF','#521A91','#1A1A1D']"
        :chart-value="Math.round(dashboardOnScreen.workload)"
        :max-value="30"
        :label="$t('DASHBOARD.donutCharts.workload')"
        :current-metric="currentMetric"
        :metric="SESSION_METRICS.WORKLOAD"
        :change-selected-metric="changeSelectedMetricAction"
      />
    </b-col>
    <b-col lg="3" md="6" v-if="checkResponsive(SESSION_METRICS.DISTANCE)">
      <chart-tab 
        v-if="dashboardOnScreen.distance !== undefined"
        :chart-colors="['#92B4C0', '#699CAE', '#397F95', '#1A1A1D']"
        :chart-value="dashboardOnScreen.distance"
        :max-value="7500"
        :label="$t('DASHBOARD.donutCharts.distance')"
        :current-metric="currentMetric"
        :metric="SESSION_METRICS.DISTANCE"
        :change-selected-metric="changeSelectedMetricAction"
      />
    </b-col>
  </b-row>
</template>

<script>
import { SESSION_METRICS } from '@/constants/SessionConsts';
import { mapGetters, mapActions } from 'vuex';
import ChartTab from '@/components/dashboard/ChartTab';
import { 
  CHANGE_SELECTED_METRIC
} from '@/store/action.types';

export default {
  name: 'DonutGraphsContainer',
  data () {
    return {
      SESSION_METRICS: SESSION_METRICS
    }
  },
  computed: {
    ...mapGetters([
      'timeAbove80PercentHrSeconds',
      'ap',
      'distance',
      'workload',
      'currentMetric',
      'dashboardOnScreen'
    ])
  },
  methods: {
    ...mapActions({
      changeSelectedMetricAction: CHANGE_SELECTED_METRIC
    }),
    checkResponsive (metric) {
      if(window.innerWidth > 768) {
        return true;
      } else {
        return this.currentMetric === metric;
      }
    }
  },
  components: {
    ChartTab
  }
}
</script>

